import { Navigate, useParams } from "react-router-dom";

// Leitet alte /grundartikel/:sku-Bookmarks auf die konsolidierte
// Detail-URL /catalog/:sku um (Katalog-Konsolidierung 2026-07-05).
export function LegacyGrundartikelSkuRedirect() {
  const { sku } = useParams<{ sku: string }>();
  return <Navigate to={`/catalog/${encodeURIComponent(sku ?? "")}`} replace />;
}
